import { FieldTypes, Field } from "@types";
import { format } from "date-fns";
import { fr, nlBE } from "date-fns/locale";

export enum FormType {
  general = "general",
  jobs = "jobs",
  campaign = "campaign",
  partners = "partners",
}

export const AIRTABLE_BASE_JOBS_NL = "Jobs NL";
export const AIRTABLE_BASE_JOBS_FR = "Jobs FR";
export const AIRTABLE_BASE_JOBS_EN = "Jobs EN";

export const AIRTABLE_BASE_PARTNERS_NL = "Partners NL";
export const AIRTABLE_BASE_PARTNERS_FR = "Partners FR";
export const AIRTABLE_BASE_PARTNERS_EN = "Partners EN";

export const AIRTABLE_BASE_CAMPAIGN_NL = "Campaign NL";
export const AIRTABLE_BASE_CAMPAIGN_FR = "Campaign FR";
export const AIRTABLE_BASE_CAMPAIGN_EN = "Campaign EN";

export const PARTNER_CONTACT_FORM_FIELDS_NL: Field[] = [
  {
    id: "name",
    name: "Name",
    label: "Naam",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "phone-number",
    name: "Phone number",
    label: "Telefoonnummer",
    type: FieldTypes.text,
  },
  {
    id: "email",
    name: "Email",
    label: "E-mail",
    type: FieldTypes.email,
    required: true,
  },
  {
    id: "via",
    name: "Reference",
    label: "Via",
    type: FieldTypes.checkbox,
    options: [
      {
        label: "Telefoon",
        value: "Telefoon",
      },
      {
        label: "E-mail",
        value: "E-mail",
      },
    ],
    conditional: "Phone number,Email",
  },
  {
    id: "subject",
    name: "Subject",
    label: "Onderwerp",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "message",
    name: "Message",
    label: "Bericht",
    type: FieldTypes.textArea,
    required: true,
  },
];

export const PARTNER_CONTACT_FORM_FIELDS_FR: Field[] = [
  {
    id: "name",
    name: "Name",
    label: "Nom",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "phone-number",
    name: "Phone number",
    label: "Numéro de téléphone",
    type: FieldTypes.text,
  },
  {
    id: "email",
    name: "Email",
    label: "E-mail",
    type: FieldTypes.email,
    required: true,
  },
  {
    id: "reference",
    name: "Reference",
    label: "Référence",
    type: FieldTypes.checkbox,
    options: [
      {
        label: "Numéro de téléphone",
        value: "Numéro de téléphone",
      },
      {
        label: "E-mail",
        value: "E-mail",
      },
    ],
    conditional: "Phone number,Email",
  },
  {
    id: "subject",
    name: "Subject",
    label: "Sujet",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "message",
    name: "Message",
    label: "Message",
    type: FieldTypes.textArea,
    required: true,
  },
];

export const PARTNER_CONTACT_FORM_FIELDS_EN: Field[] = [
  {
    id: "name",
    name: "Name",
    label: "Name",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "phone-number",
    name: "Phone number",
    label: "Phone number",
    type: FieldTypes.text,
  },
  {
    id: "email",
    name: "Email",
    label: "Email",
    type: FieldTypes.email,
    required: true,
  },
  {
    id: "via",
    name: "Reference",
    label: "Contact me by",
    type: FieldTypes.checkbox,
    options: [
      {
        label: "Phone",
        value: "Phone",
      },
      {
        label: "Email",
        value: "Email",
      },
    ],
    conditional: "Phone number,Email",
  },
  {
    id: "subject",
    name: "Subject",
    label: "Subject",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "message",
    name: "Message",
    label: "Message",
    type: FieldTypes.textArea,
    required: true,
  },
];

export const JOBS_CONTACT_FORM_FIELDS_NL: Field[] = [
  {
    id: "name",
    name: "Name",
    label: "Naam",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "phone-number",
    name: "Phone number",
    label: "Telefoonnummer",
    type: FieldTypes.text,
  },
  {
    id: "email",
    name: "Email",
    label: "E-mail",
    type: FieldTypes.email,
    required: true,
  },
  {
    id: "via",
    name: "Reference",
    label: "Via",
    type: FieldTypes.checkbox,
    options: [
      {
        label: "Telefoon",
        value: "Telefoon",
      },
      {
        label: "E-mail",
        value: "E-mail",
      },
    ],
    conditional: "Phone number,Email",
  },
  {
    id: "subject",
    name: "Subject",
    label: "Onderwerp",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "message",
    name: "Message",
    label: "Bericht",
    type: FieldTypes.textArea,
    required: true,
  },
];

export const JOBS_CONTACT_FORM_FIELDS_FR: Field[] = [
  {
    id: "name",
    name: "Name",
    label: "Nom",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "phone-number",
    name: "Phone number",
    label: "Numéro de téléphone",
    type: FieldTypes.text,
  },
  {
    id: "email",
    name: "Email",
    label: "E-mail",
    type: FieldTypes.email,
    required: true,
  },
  {
    id: "reference",
    name: "Reference",
    label: "Référence",
    type: FieldTypes.checkbox,
    options: [
      {
        label: "Numéro de téléphone",
        value: "Numéro de téléphone",
      },
      {
        label: "E-mail",
        value: "E-mail",
      },
    ],
    conditional: "Phone number,Email",
  },
  {
    id: "subject",
    name: "Subject",
    label: "Sujet",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "message",
    name: "Message",
    label: "Message",
    type: FieldTypes.textArea,
    required: true,
  },
];

export const JOBS_CONTACT_FORM_FIELDS_EN: Field[] = [
  {
    id: "name",
    name: "Name",
    label: "Name",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "phone-number",
    name: "Phone number",
    label: "Phone number",
    type: FieldTypes.text,
  },
  {
    id: "email",
    name: "Email",
    label: "Email",
    type: FieldTypes.email,
    required: true,
  },
  {
    id: "via",
    name: "Reference",
    label: "Preferred contact method",
    type: FieldTypes.checkbox,
    options: [
      {
        label: "Phone",
        value: "Phone",
      },
      {
        label: "Email",
        value: "Email",
      },
    ],
    conditional: "Phone number,Email",
  },
  {
    id: "subject",
    name: "Subject",
    label: "Subject",
    type: FieldTypes.text,
    required: true,
  },
  {
    id: "message",
    name: "Message",
    label: "Message",
    type: FieldTypes.textArea,
    required: true,
  },
];

export const getCampaignFormFieldsNL = (
  dates?: { date: string }[],
  disablePartnershipEnterprise?: boolean,
): Field[] => {
  const dateOptions = dates?.map(({ date }) => ({
    label: format(new Date(date), "dd-MM-yyyy", { locale: nlBE }),
    value: date,
  }));

  return [
    {
      id: "name",
      name: "Name",
      label: "Naam",
      type: FieldTypes.text,
      required: true,
    },
    {
      id: "email",
      name: "Email",
      label: "E-mail",
      type: FieldTypes.email,
      required: true,
    },
    {
      id: "phone-number",
      name: "Phonenumber",
      label: "Telefoonnummer",
      type: FieldTypes.text,
    },
    ...(!disablePartnershipEnterprise
      ? [
          {
            id: "name-partnership-company",
            name: "Name partnership/company",
            label: "Naam venootschap/onderneming",
            type: FieldTypes.text,
          },
        ]
      : []),
    {
      id: "message",
      name: "Message",
      label: "Bericht",
      type: FieldTypes.textArea,
      required: true,
    },
    ...(dateOptions && dateOptions?.length > 0
      ? [
          {
            id: "Date",
            name: "Date",
            label: "Datum",
            type: FieldTypes.select,
            options: dateOptions,
          },
        ]
      : []),
    {
      id: "Referral",
      name: "Referral",
      label: "Referral",
      type: FieldTypes.hidden,
    },
    {
      id: "Campaign name",
      name: "Campaign name",
      label: "Campaign name",
      type: FieldTypes.hidden,
    },
  ];
};

export const getCampaignFormFieldsFR = (
  dates?: { date: string }[],
  disablePartnershipEnterprise?: boolean,
): Field[] => {
  const dateOptions = dates?.map(({ date }) => {
    return {
      label: format(new Date(date), "dd-MM-yyyy", { locale: fr }),
      value: date,
    };
  });

  return [
    {
      id: "name",
      name: "Name",
      label: "Nom",
      type: FieldTypes.text,
      required: true,
    },
    {
      id: "email",
      name: "Email",
      label: "Courriel",
      type: FieldTypes.email,
      required: true,
    },
    {
      id: "phone-number",
      name: "Phonenumber",
      label: "Téléphone",
      type: FieldTypes.text,
    },
    ...(!disablePartnershipEnterprise
      ? [
          {
            id: "name-partnership-company",
            name: "Name partnership/company",
            label: "Nom partnership/entreprise",
            type: FieldTypes.text,
          },
        ]
      : []),
    {
      id: "message",
      name: "Message",
      label: "Message",
      type: FieldTypes.textArea,
      required: true,
    },
    ...(dateOptions
      ? [
          {
            id: "Date",
            name: "Date",
            label: "Date",
            type: FieldTypes.select,
            options: dateOptions,
          },
        ]
      : []),
    {
      id: "Referral",
      name: "Referral",
      label: "Referral",
      type: FieldTypes.hidden,
    },
    {
      id: "Campaign name",
      name: "Campaign name",
      label: "Campaign name",
      type: FieldTypes.hidden,
    },
  ];
};

export const getCampaignFormFieldsEN = (
  dates?: { date: string }[],
  disablePartnershipEnterprise?: boolean,
): Field[] => {
  const dateOptions = dates?.map(({ date }) => ({
    label: format(new Date(date), "dd-MM-yyyy", { locale: nlBE }),
    value: date,
  }));

  return [
    {
      id: "name",
      name: "Name",
      label: "Name",
      type: FieldTypes.text,
      required: true,
    },
    {
      id: "email",
      name: "Email",
      label: "Email",
      type: FieldTypes.email,
      required: true,
    },
    {
      id: "phone-number",
      name: "Phonenumber",
      label: "Phone number",
      type: FieldTypes.text,
    },
    ...(!disablePartnershipEnterprise
      ? [
          {
            id: "name-partnership-company",
            name: "Name partnership/company",
            label: "Name partnership/company",
            type: FieldTypes.text,
          },
        ]
      : []),
    {
      id: "message",
      name: "Message",
      label: "Message",
      type: FieldTypes.textArea,
      required: true,
    },
    ...(dateOptions && dateOptions?.length > 0
      ? [
          {
            id: "Date",
            name: "Date",
            label: "Date",
            type: FieldTypes.select,
            options: dateOptions,
          },
        ]
      : []),
    {
      id: "Referral",
      name: "Referral",
      label: "Referral",
      type: FieldTypes.hidden,
    },
    {
      id: "Campaign name",
      name: "Campaign name",
      label: "Campaign name",
      type: FieldTypes.hidden,
    },
  ];
};
